import { errorMessagesListFromResponse } from '../../../../../../../helpers/errors';
import useAsyncValue from '../../../../../../../hooks/useAsyncValue';
import { post } from '../../../../../../../redux/api';
import type { FailedFetchResponse } from '../../../../../../../helpers/errors';
import type { LDAPStrategy } from '../../../../../../../types';
import type { TestUser } from '../../types';

/**
 * Hook for testing LDAP connection
 */
function useTestLDAP() {
  const { setResolve, setPending, setReject, value, isLoading, errors } = useAsyncValue();

  const onTestLDAP = async (request: { ldap: LDAPStrategy; user: TestUser }) => {
    try {
      setPending();
      const { data } = await post('/api/ldap/test', request);
      setResolve(data);
    } catch (error: unknown) {
      setReject(errorMessagesListFromResponse(error as FailedFetchResponse).map((e) => e.toString()));
    }
  };

  return {
    onTestLDAP,
    value,
    isLoading,
    errors,
  };
}

export default useTestLDAP;
